import { Component, inject, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {
  handleRequestError,
  MenuItem,
  menuItems,
  Refreshable,
  RefreshService,
} from '@softline/application';
import { Store } from '@softline/core';
import {
  SOFTLINE_FEATURE_TICKET,
  SOFTLINE_FEATURE_TICKET_CONTACT,
  SOFTLINE_FEATURE_TICKET_HOTLINE,
  SOFTLINE_FEATURE_TICKET_TICKET_TYPE,
  TicketContactStore,
  TicketHotlineStore,
  TicketTypeStore,
} from '../ticket.shared';
import { TicketRepository } from '../repositories/ticket.repository';

@Component({
  selector: 'soft-ticket-app',
  imports: [RouterModule],
  templateUrl: './ticket-app.component.html',
  styleUrls: ['./ticket-app.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [TicketRepository],
})
export class TicketAppComponent implements OnInit, OnDestroy, Refreshable {
  private readonly store = inject(Store);
  protected readonly router = inject(Router);
  private readonly refreshService = inject(RefreshService);
  private readonly injector = inject(Injector);

  constructor() {
    menuItems(
      () =>
        [
          {
            type: 'route',
            outlet: 'nav',
            icon: 'fa-regular fa-list',
            name: '#TICKETS.MENU.OVERVIEW',
            routerLink: ['/ticket'],
          },
          {
            type: 'route',
            outlet: 'nav',
            icon: 'fa-regular fa-magnifying-glass',
            name: '#TICKETS.MENU.SEARCH',
            routerLink: ['/ticket/search'],
          },
          {
            type: 'route',
            outlet: 'nav',
            icon: 'fa-regular fa-square-plus',
            name: '#TICKETS.MENU.CREATE',
            routerLink: ['/ticket/create'],
          },
        ] as MenuItem[]
    );
  }

  async ngOnInit(): Promise<void> {
    this.refreshService.add(this);

    try {
      this.loadData();
    } catch (e) {
      handleRequestError(e, this.injector, { show: true });
    }
  }

  ngOnDestroy(): void {
    this.refreshService.remove(this);
  }

  loadData(): void {
    this.store.dispatch(
      SOFTLINE_FEATURE_TICKET_HOTLINE,
      TicketHotlineStore.actions.loadMany,
      { clear: true }
    );
    this.store.dispatch(
      SOFTLINE_FEATURE_TICKET_TICKET_TYPE,
      TicketTypeStore.actions.loadMany,
      { clear: true }
    );
    this.store.dispatch(
      SOFTLINE_FEATURE_TICKET_CONTACT,
      TicketContactStore.actions.loadMany,
      { clear: true }
    );
  }

  async refresh(): Promise<void> {
    try {
      this.loadData();
    } catch (e) {
      handleRequestError(e, this.injector, { show: true });
    }
  }
}
